<template>
    <div class="admin-pages">
        <PageTitle icon="mdi-chart-gantt" main="Admin"
            sub="Cadastros & Cia" />
                    
        <div class="admin-pages-tabs">
            <v-tabs
            background-color="indigo"
            slider-color="indigo lighten-5"
            v-model="tabActived"
            grow
            center-active
            dark
            icons-and-text
            >
                <v-tab
                    v-for="n in nav.length"
                    :key="n"
                    ripple
                    class="ma-0"
                    >
                    {{ nav[n-1].title }}
                    <v-icon>{{ nav[n-1].icon }}</v-icon>
                </v-tab>
                
                <v-tab-item
                    v-for="n in nav.length"
                    :key="n">
                    <v-card flat>
                        <v-card-text>
                            <keep-alive>
                                <Register 
                                    :title="nav[n-1].title"
                                    :scope="nav[n-1].scope"
                                    :path="nav[n-1].path"
                                    :segment="nav[n-1].segment"
                                    :arrayChilds="nav[n-1].arrayChilds"
                                    :minorScopes="nav[n-1].minorScopes"
                                    :componentHeader="nav[n-1].componentHeader"
                                    :disableNewItem="nav[n-1].disableNewItem"
                                    :enableImport="nav[n-1].enableImport"
                                    :headers="nav[n-1].headers"
                                    :subHeaders="nav[n-1].subHeaders"
                                    :expand="nav[n-1].expand"
                                    :maxWidthForm="nav[n-1].maxWidthForm"
                                    :maxWidthFormImport="nav[n-1].maxWidthFormImport"
                                    :itemModel="nav[n-1].itemModel"
                                    :inputs="nav[n-1].inputs"
                                    :inputsImport="nav[n-1].inputsImport"
                                />
                            </keep-alive>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Register from '../register/Default'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('admin')

export default {
    name: 'AdminPages',
    components: { PageTitle, Register },
    data: function() {
        return {
            nav: [
                /* Users */
                {
                    title: 'Usuários',
                    icon: "mdi-account-group",
                    path: 'users',
                    scope: 'users',
                    headers: [
                        { text: 'ID', value: '_id', options: {} },
                        { text: 'Nome', value: 'name', options: {} },
                        { text: 'E-mail', value: 'email', options: {} },
                        { text: 'Administrador', value: 'admin', sortable: false, options: {} },
                        { 
                            text: 'Ações', 
                            value: 'actions', 
                            sortable: false, 
                            align: 'center', 
                            options: { 
                                tdClass: 'text-center', 
                            } 
                        }
                    ],
                    maxWidthForm: 50,
                    inputs: [
                        { 
                            vType: 'v-text-field', 
                            label: 'Nome Completo', 
                            vModel: 'name', 
                            required: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Apelido', 
                            vModel: 'nickname', 
                            required: true,
                            class: 'xs12 sm6 md6 lg6 xl6', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Email', 
                            vModel: 'email', 
                            required: true,
                            class: 'xs12 sm6 md6 lg6 xl6', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Senha', 
                            vModel: 'password', 
                            type: 'password',
                            // appendIcon: 'input.show ? "visibility" : "visibility_off"', 
                            hint: "Minimo de 8 caracteres",
                            required: true,
                            class: 'xs12 sm6 md6 lg6 xl6', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Confirmação de Senha', 
                            vModel: 'confirmPassword', 
                            type: 'password',
                            hint: "Minimo de 8 caracteres",
                            required: true,
                            class: 'xs12 sm6 md6 lg6 xl6',
                        },
                        { 
                            vType: 'v-switch', 
                            label: 'Admin', 
                            vModel: 'admin',
                            required: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['tabActived']),
        
        tabActived: {
			get () {
				return this.$store.state.registers.tabActived
			},
			set (value) {
				this.$store.commit('registers/setTabActived', value)
			}
		},
    },
}
</script>

<style>

</style>